import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import type { ClienteIntermedio } from "@interfaces/user.interface";

export interface ClientesResponse {
  data: ClienteIntermedio[];
  total: number;
}

export interface ClienteIntermedioSelectResponse {
  options: { value: string; label: string }[];
}

export const useClientesIntermedios = (
  page: number,
  limit: number,
  search: string
) => {
  return useQuery<ClientesResponse, Error>({
    queryKey: ["clientesIntermedios", page, limit, search],
    queryFn: async () => {
      const response = await axiosInstance.get(
        "/clientes-intermedios/paginated",
        {
          params: { page, limit, search },
        }
      );
      return response.data;
    },
    placeholderData: keepPreviousData,
  });
};

export const useSelectClientesIntermedios = () => {
  return useQuery<ClienteIntermedioSelectResponse, Error>({
    queryKey: ["selectClientesIntermedios"],
    queryFn: async () => {
      const response = await axiosInstance.get(
        "/clientes-intermedios/select-options"
      );
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
  });
};
